module.exports = __webpack_public_path__ + "img/pago.6030e84d.png";